// src/components/common/PopupPortal.jsx
import { createPortal } from "react-dom";

const PopupPortal = ({ children }) => {
  const popupRoot = document.getElementById("popup-root");

  if (popupRoot) {
    return createPortal(children, popupRoot);
  }

  if (!document.body) return null;

  return createPortal(children, document.body);
};

export default PopupPortal;